import React, { Component } from 'react';

export default class Lightbox extends Component {
    render() {
        const { contents, open } = this.props;

        if (contents && open === true) {
            return (
                <div className="lightbox">
                    <div className="container">
                        <div className="lightbox-content col-12">
                            <button className="lightbox-close" onClick={ this.props.toggle }></button>

                            { contents }
                        </div>
                    </div>
                </div>
            )
        }
        
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/partials/Lightbox.js